import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Counterparty, ErrorMessage } from '@shared/models';

export const CounterpartyDetailsActions = createActionGroup({
  source: 'Counterparty Details',
  events: {
    'Load Counterparty Details': emptyProps,
    'Load Counterparty Details Success': props<{ counterpartyDetails: Counterparty }>(),
    'Load Counterparty Details Failure': props<{ error: ErrorMessage }>(),
  },
});
